import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyBb97qGtobHR0XDxekvWyNkmEKcedAzbfg',
  authDomain: 'bulkzone-183e8.firebaseapp.com',
  projectId: 'bulkzone-183e8',
  storageBucket: 'bulkzone-183e8.appspot.com',
  messagingSenderId: '528610471125',
  appId: '1:528610471125:web:6c40304bdc46f888b1865c',
  measurementId: 'G-0QLPER54WB'
}

export const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const auth = getAuth(app)
